export const makeUrl = (url?: string, path?: string, proxy?: string) =>
  process.env.NODE_ENV === 'development' && !!proxy ? `${proxy}${path}` : `${url}${path}`;
